import { createApp } from 'vue'

import App from './App.vue'
import router from "./router";
import {
  BAlert, BButton, BModal, BForm, BFormGroup, BFormInput,
  BFormSelect, BFormSelectOption, BFormCheckbox, BFormRadio,
  BProgress, BBreadcrumb, BDropdown, BDropdownItem,
  BDropdownDivider, BPagination, BTooltip, BFormTextarea
} from './plugins/bootstrap-stubs';
import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from 'vue3-scroll-spy';
import {userService} from "@/helpers/authservice/user.service";
import jwtInterceptor from './helpers/authservice/auth-header'

import Maska from 'maska'
import {i18n} from "./i18n.js"
import { initFirebaseBackend } from './authUtils'
import { configureFakeBackend } from './helpers/fake-backend';
import { GoogleMapsPlugin } from "@/plugins/googleMaps";

jwtInterceptor();
userService.refreshToken();

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';

import store from "./state/store";

import "../src/design/app.scss";


const app = createApp(App)

app.component('BAlert', BAlert)
app.component('b-alert', BAlert)
app.component('BButton', BButton)
app.component('b-button', BButton)
app.component('BModal', BModal)
app.component('b-modal', BModal)
app.component('BForm', BForm)
app.component('b-form', BForm)
app.component('BFormGroup', BFormGroup)
app.component('b-form-group', BFormGroup)
app.component('BFormInput', BFormInput)
app.component('b-form-input', BFormInput)
app.component('BFormSelect', BFormSelect)
app.component('b-form-select', BFormSelect)
app.component('BFormSelectOption', BFormSelectOption)
app.component('b-form-select-option', BFormSelectOption)
app.component('BFormCheckbox', BFormCheckbox)
app.component('b-form-checkbox', BFormCheckbox)
app.component('BFormRadio', BFormRadio)
app.component('b-form-radio', BFormRadio)
app.component('BProgress', BProgress)
app.component('b-progress', BProgress)
app.component('BBreadcrumb', BBreadcrumb)
app.component('b-breadcrumb', BBreadcrumb)
app.component('BDropdown', BDropdown)
app.component('b-dropdown', BDropdown)
app.component('BDropdownItem', BDropdownItem)
app.component('b-dropdown-item', BDropdownItem)
app.component('BDropdownDivider', BDropdownDivider)
app.component('b-dropdown-divider', BDropdownDivider)
app.component('BPagination', BPagination)
app.component('b-pagination', BPagination)
app.component('BTooltip', BTooltip)
app.component('b-tooltip', BTooltip)
app.component('BFormTextarea', BFormTextarea)
app.component('b-form-textarea', BFormTextarea)

app
  .use(store)
  .use(router)
  .use(VueApexCharts)
  .use(vClickOutside)
  .use(i18n)
  .use(registerScrollSpy)
  .use(Maska)
  .use(GoogleMapsPlugin)
  .mount('#app')
